// Small display helpers.

/** "5h 12m", "12m 30s", "45s" — for countdowns like the next login reward. */
export function formatDuration(ms: number): string {
  const total = Math.max(0, Math.ceil(ms / 1000));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m ${s}s`;
  return `${s}s`;
}

const SUIT_SYMBOL = { s: "♠", h: "♥", d: "♦", c: "♣" } as const;
const SUIT_NAME = { s: "spades", h: "hearts", d: "diamonds", c: "clubs" } as const;
const RANK_LABEL: Record<string, string> = { T: "10", J: "J", Q: "Q", K: "K", A: "A" };
const RANK_NAME: Record<string, string> = { T: "Ten", J: "Jack", Q: "Queen", K: "King", A: "Ace" };

export type SuitKey = keyof typeof SUIT_SYMBOL;

/** Display parts of a 2-char card code such as "Td". */
export function cardParts(card: string): { rank: string; suit: string; red: boolean; label: string } {
  const r = card[0] ?? "?";
  const s = (card[1] ?? "s") as SuitKey;
  const rank = RANK_LABEL[r] ?? r;
  const suit = SUIT_SYMBOL[s] ?? "?";
  const name = `${RANK_NAME[r] ?? r} of ${SUIT_NAME[s] ?? "?"}`;
  return { rank, suit, red: s === "h" || s === "d", label: name };
}

/** 1234 -> "1,234" */
export function formatCoins(n: number): string {
  return n.toLocaleString("en-US");
}
